import { BaseService } from 'core/services';
import ProductRouteService from './ProductRouteService';

class ProductService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProductRouteService());
    }

    async getPumps(){
        const url = this.routeService.getPumps();
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
    
    async getEachProduct(productId){
        const url = this.routeService.getEachProduct(productId);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async copyProduct(id){
        const url = this.routeService.copyProduct(id);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }
    
    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }
}

export default ProductService;
